import httpClient from "@plugins/http";
export default {
  /**
   *
   * @param {*} resourceType
   * @param {*} resourceUuid
   */
  checkLockOwner(resourceType, resourceUuid, browserTabUuid) {
    return httpClient.post(`/apis/lockresource/islocked/${resourceType}/${resourceUuid}`, null, {
      params: {
        browserTabUuid,
      },
    });
  },
  /**
   * Check Lock Owner of Resource
   * True even if it is locked by myself.
   * @param {*} resourceType
   * @param {*} resourceUuid
   */
  async isStrictlyLocked(resourceType, resourceUuid, browserTabUuid) {
    return await httpClient.post(
      `/apis/lockresource/isstrictlylocked/${resourceType}/${resourceUuid}`,
      null,
      {
        params: {
          browserTabUuid,
        },
      },
    );
  },

  /**
   * Lock Resource
   * @param {*} resourceType
   * @param {*} resourceUuid
   */
  lock(resourceType, resourceUuid, browserTabUuid, overrideExistingLock = false) {
    return httpClient.post(`/apis/lockresource/lock/${resourceType}/${resourceUuid}`, {
      browserTabUuid,
      overrideExistingLock,
    });
  },
  /**
   * Unlock Resource
   * @param {*} resourceType
   * @param {*} resourceUuid
   */
  unlock(resourceType, resourceUuid, browserTabUuid) {
    return httpClient.post(`/apis/lockresource/unlock/${resourceType}/${resourceUuid}`, null, {
      params: {
        browserTabUuid,
      },
    });
  },
};
